import { render } from "./AdminEvents.vue?vue&type=template&id=154f5a24&scoped=true"
import script from "./AdminEvents.vue?vue&type=script&lang=js"
export * from "./AdminEvents.vue?vue&type=script&lang=js"

import "./AdminEvents.vue?vue&type=style&index=0&id=154f5a24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154f5a24"]])

export default __exports__